import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

// project imports
import Loadable from '../components/Loadable';
import DashboardLayout from '../layout/Dashboard';

// render- Dashboard
// const SingleLandingPage = Loadable(lazy(() => import('../section/auth/SingleLandingPage')))
const DashboardDefault = Loadable(lazy(() => import('../pages/Dashboard')));
const Users = Loadable(lazy(() => import('../pages/Users/users')))
const AddUsers = Loadable(lazy(() => import('../pages/Users/AddUsers')))
const NGODetails = Loadable(lazy(() => import('../pages/NGO/ngo')))
const InstituteDetails = Loadable(lazy(() => import('../pages/Institute/instituition')))
const InstituteRequests = Loadable(lazy(() => import('../pages/Institute/InstitutionRequests')))
const AddInstitute = Loadable(lazy(() => import('../pages/Institute/addInstitute')))
// const FeeStructure = Loadable(lazy(() => import('../pages/Institute/FeesStructureForm')))
const StudentDetails = Loadable(lazy(() => import('../pages/StudentDetails/studentDetails')))
const StudentRequestDetails = Loadable(lazy(() => import('../pages/StudentDetails/requestDetails')))
const DonorDetails = Loadable(lazy(() => import('../pages/DonorDetails/donorDetails')))
const DonationHistory = Loadable(lazy(() => import('../pages/DonorDetails/singleDonorDetails')))
const Login = Loadable(lazy(() => import('../section/auth/LoginForm')));
const OnBoardingForm = Loadable(lazy(() => import('../pages/OnboardingForm/onBoardingForms')))
const RequestDetails = Loadable(lazy(() => import('../pages/RequestDetails/RequestDetails')))
const SingleRequestDetails = Loadable(lazy(() => import('../pages/RequestDetails/SingleRequestDetails')))
const EducationRequestDetails = Loadable(lazy(() => import('../pages/EducationRequest/EducationRequestDetails')))
const FundDisbursement = Loadable(lazy(() => import('../pages/FundDisbursement/FundDisbursement')))
const SingleFundDisbursement = Loadable(lazy(() => import('../pages/FundDisbursement/SingleFundDisbursement')))
const Donations = Loadable(lazy(() => import('../pages/Donations/Donations')))
const VerificationDetails = Loadable(lazy(() => import('../pages/Payments/Payments')))
const InstitutionRegistration = Loadable(lazy(() => import('../section/auth/InstitutionRegistration')))
// const StudentProfile = Loadable(lazy(() => import('../pages/StudentDetails/studentProfile')))
const NotFound = Loadable(lazy(() => import('../section/auth/ErrorPage')))
const AuthorizedUsers = Loadable(lazy(() => import('../pages/Institute/AuthorizedUsers')))
const AuthorizedUsersAdd = Loadable(lazy(() => import('../pages/Institute/AddUsers')))
const AuthorizedUsersEdit = Loadable(lazy(() => import('../pages/Institute/AddUsers')))
const InstitutionEducationRequest = Loadable(lazy(() => import('../pages/Institute/EducationRequest')))
const ContactUs = Loadable(lazy(() => import('../section/website/ContactUs')))
const TermsConditions = Loadable(lazy(() => import('../section/website/TermsAndConditions')))
const SingleDonation = Loadable(lazy(() => import('../pages/Donations/SingleDonation')))
const PrivacyPolicy = Loadable(lazy(() => import('../section/website/PrivacyPolicy')))
const About = Loadable(lazy(() => import('../section/website/About')))
const Home = Loadable(lazy(() => import('../section/website/Home')))
const Gallery = Loadable(lazy(() => import('../section/website/Gallery')))
const OurApps = Loadable(lazy(() => import('../section/website/OurApps')))
const TestPage = Loadable(lazy(() => import('../section/website/HeroSection')))
const QuickDonations = Loadable(lazy(() => import('../pages/QuickDonations/QuickDonations')))
const DeleteAccount = Loadable(lazy(() => import('../section/website/DeleteAccount')))
const InstitutionInvitation = Loadable(lazy(() => import('../pages/Institute/InstitutionInvitation')))
const Faqs = Loadable(lazy(() => import('../section/website/faq')))

// ==============================|| MAIN ROUTING ||============================== //

const getCurrentRole = () => {
  try {
    const mainUser = JSON.parse(sessionStorage.getItem('main-user'));
    return mainUser?.roleId?.name || mainUser?.user?.roleId?.name;
  } catch (e) {
    return null;
  }
};

const getDashboardPathForRole = (role) => {
  if (role === 'Admin' || role === 'Super Admin') return '/admin/dashboard';
  if (role === 'NGO') return '/ngo/dashboard';
  if (role === 'Institution') return '/institution/dashboard';
  return '/';
};

const LoginGuard = () => {
  const role = getCurrentRole();

  if (role) {
    const target = getDashboardPathForRole(role);
    return <Navigate to={target} replace />;
  }

  return <Login />;
};

const RoleGuard = ({ allowedRole, children }) => {
  const role = getCurrentRole();

  if (!role) {
    return <Navigate to="/login" replace />;
  }

  return role === allowedRole ? children : <NotFound />;
};
const MainRoutes = {
  path: "/",
  // element: <SingleLandingPage />,
  children: [
    {
      index: true,
      element: <Home />
    },
    {
      path: 'about',
      element: <About />
    },
    {
      path: 'test',
      element: <TestPage />
    },
    {
      path: 'our-app',
      element: <OurApps />
    },
    {
      path: 'gallery',
      element: <Gallery />
    },
    {
      path: 'terms-and-conditions',
      element: <TermsConditions />
    },
    {
      path: 'privacy-policy',
      element: <PrivacyPolicy />
    },
    {
      path: 'contact',
      element: <ContactUs />
    },
    {
      path: 'delete-account',
      element: <DeleteAccount />
    },
    {
      path: 'faq',
      element: <Faqs />
    },
    {
      path: "login",
      element: <LoginGuard />
    },
    {
      path: 'institution-registration',
      element: <InstitutionRegistration />
    },
    {
      path: "/admin",
      element: (
        <RoleGuard allowedRole="Admin">
          <DashboardLayout />
        </RoleGuard>
      ),
      children: [
        {
          path: 'dashboard',
          element: <DashboardDefault />
        },
        {
          path: 'users',
          element: <Users />
        },
        {
          path: 'users/add-users',
          element: <AddUsers mode="add" />
        },
        {
          path: 'users/edit-user/:id',
          element: <AddUsers mode="edit" />
        },
        {
          path: 'users/edit-userprofile/:id',
          element: <AddUsers mode="edit" />
        },
        {
          path: 'users/view-userprofile/:id',
          element: <AddUsers mode="view" />
        },
        {
          path: 'ngo-details',
          element: <NGODetails />
        },
        {
          path: 'institution',
          element: <InstituteDetails />
        },
        {
          path: 'institution/add/:section',
          element: <AddInstitute />
        },
        {
          path: 'institution/:id/add/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/edit/:id/:section',
          element: <AddInstitute />
        },
        {
          path: 'institution/edit/:id/:edit',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/institution_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/:id/add/fees-structure',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/users',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/education-requests',
          element: <AddInstitute />
        },
        {
          path: 'institution/add/beneficiaries',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/fees-structure',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/beneficiaries',
          element: <AddInstitute />
        },
        // {
        //   path: 'institution/:id/fees-structure',
        //   element: <FeeStructure />
        // },
        {
          path: 'institution-requests',
          element: <InstituteRequests />
        },
        {
          path: 'institution-invitation',
          element: <InstitutionInvitation />
        },
        {
          path: 'institution/education-requests/:id',
          element: <InstitutionEducationRequest />
        },
        {
          path: 'beneficiary',
          element: <StudentDetails />
        },
        {
          path: 'beneficiary/:instituteId',
          element: <StudentDetails />
        },
        {
          path: 'beneficiary/add',
          element: <OnBoardingForm />
        },
        {
          path: 'beneficiary/view/:id',
          element: <OnBoardingForm mode="view" />
        },
        {
          path: 'beneficiary/edit/:id',
          element: <OnBoardingForm mode="edit" />
        },
        {
          path: 'beneficiary/request-details/:id',
          element: <StudentRequestDetails />
        },
        {
          path: 'donor',
          element: <DonorDetails />
        },
        {
          path: 'donor/:id',
          element: <DonationHistory />
        },
        {
          path: 'quick-donations',
          element: <QuickDonations />
        },
        {
          path: 'shadow',
          element: <DashboardDefault />
        },
        {
          path: 'requests',
          element: <RequestDetails />
        },
        {
          path: 'requests/:id',
          element: <SingleRequestDetails />
        },
        {
          path: 'education-request/:id',
          element: <EducationRequestDetails />
        },
        {
          path: 'fund-disbursement',
          element: <FundDisbursement />
        },
        {
          path: 'single-fund-disbursement',
          element: <SingleFundDisbursement />
        },
        {
          path: 'donations',
          element: <Donations />
        },
        {
          path: 'donations/:id',
          element: <SingleDonation />
        },
        {
          path: 'payments',
          element: <VerificationDetails />
        },
        {
          path: "*",
          element: <NotFound />,
        }
      ]
    },
    {
      path: "/super-admin",
      element: (
        <RoleGuard allowedRole="Super Admin">
          <DashboardLayout />
        </RoleGuard>
      ),
      children: [
        {
          path: 'dashboard',
          element: <DashboardDefault />
        },
        {
          path: 'users',
          element: <Users />
        },
        {
          path: 'users/add-users',
          element: <AddUsers mode="add" />
        },
        {
          path: 'users/edit-user/:id',
          element: <AddUsers mode="edit" />
        },
        {
          path: 'users/view-user/:id',
          element: <AddUsers mode="view" />
        },
        {
          path: 'ngo-details',
          element: <NGODetails />
        },
        {
          path: 'institution',
          element: <InstituteDetails />
        },
        {
          path: 'institution/add/:section',
          element: <AddInstitute />
        },
        {
          path: 'institution/edit/:id',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/fees-structure',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/beneficiaries',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/users',
          element: <AddInstitute />
        },
        {
          path: 'beneficiary',
          element: <StudentDetails />
        },
        {
          path: 'beneficiary/:instituteId',
          element: <StudentDetails />
        },
        {
          path: 'beneficiary/add',
          element: <OnBoardingForm />
        },
        {
          path: 'beneficiary/view/:id',
          element: <OnBoardingForm mode="view" />
        },
        {
          path: 'beneficiary/edit/:id',
          element: <OnBoardingForm mode="edit" />
        },
        {
          path: 'beneficiary/request-details/:id',
          element: <StudentRequestDetails />
        },
        {
          path: 'donor',
          element: <DonorDetails />
        },
        {
          path: 'donor/:id',
          element: <DonationHistory />
        },
        {
          path: 'quick-donations',
          element: <QuickDonations />
        },
        {
          path: 'shadow',
          element: <DashboardDefault />
        },
        {
          path: 'requests',
          element: <RequestDetails />
        },
        {
          path: 'fund-disbursement',
          element: <FundDisbursement />
        },
        {
          path: 'donations',
          element: <Donations />
        },
        {
          path: 'payments',
          element: <VerificationDetails />
        }
      ]
    },
    {
      path: "/ngo",
      element: (
        <RoleGuard allowedRole="NGO">
          <DashboardLayout />
        </RoleGuard>
      ),
      children: [
        {
          path: 'dashboard',
          element: <DashboardDefault />
        },
        {
          path: 'users',
          element: <Users />
        },
        {
          path: 'users/edit-userprofile/:id',
          element: <AddUsers mode="edit" />
        },
        {
          path: 'users/view-userprofile/:id',
          element: <AddUsers mode="view" />
        },
        {
          path: 'institution',
          element: <InstituteDetails />
        },
        {
          path: 'institution-requests',
          element: <InstituteRequests />
        },
        {
          path: 'institution/add',
          element: <AddInstitute />
        },
        {
          path: 'institution/edit/:id',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id',
          element: <AddInstitute />
        },
        {
          path: 'institution/add/:section',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/institution_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/fees-structure',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/users',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/beneficiaries',
          element: <AddInstitute />
        },
        {
          path: 'beneficiary',
          element: <StudentDetails />
        },
        {
          path: 'beneficiary/add',
          element: <OnBoardingForm />
        },
        {
          path: 'beneficiary/view/:id',
          element: <OnBoardingForm mode="view" />
        },
        {
          path: 'beneficiary/edit/:id',
          element: <OnBoardingForm mode="edit" />
        },
        {
          path: 'beneficiary/request-details/:id',
          element: <StudentRequestDetails />
        },
        {
          path: 'donor',
          element: <DonorDetails />
        },
        {
          path: 'donor/:id',
          element: <DonationHistory />
        },
        {
          path: 'requests',
          element: <RequestDetails />
        },
        {
          path: 'requests/:id',
          element: <SingleRequestDetails />
        },
        {
          path: 'donations',
          element: <Donations />
        },
        {
          path: 'donations/:id',
          element: <SingleDonation />
        },
        {
          path: 'quick-donations',
          element: <QuickDonations />
        }
      ]
    },
    {
      path: "/institution",
      element: (
        <RoleGuard allowedRole="Institution">
          <DashboardLayout />
        </RoleGuard>
      ),
      children: [
        {
          path: 'dashboard',
          element: <DashboardDefault />
        },
        {
          path: 'authorized-users',
          element: <AuthorizedUsers />
        },
        {
          path: 'authorized-users/add',
          element: <AuthorizedUsersAdd mode="add" />
        },
        {
          path: 'authorized-users/edit/:id',
          element: <AuthorizedUsersEdit mode="edit" />
        },
        {
          path: 'education-request',
          element: <InstitutionEducationRequest />
        },
        {
          path: 'institution/add/:section',
          element: <AddInstitute />
        },
        {
          path: 'institution/:id/add/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/edit/:id/:section',
          element: <AddInstitute />
        },
        {
          path: 'institution/edit/:id/:edit',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id',
          element: <AddInstitute />
        },
        {
          path: 'profile/view/:id',
          element: <AddInstitute />
        },
        {
          path: 'profile/edit/:id/:edit',
          element: <AddInstitute />
        },
        {
          path: 'profile/view/:id/institution_details',
          element: <AddInstitute />
        },
        {
          path: 'profile/edit/:id/institution_details',
          element: <AddInstitute />
        },
        {
          path: 'profile/view/:id/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'profile/view/:id/fees-structure',
          element: <AddInstitute />
        },
        {
          path: 'profile/view/:id/beneficiaries',
          element: <AddInstitute />
        },
        {
          path: 'profile/edit/:id/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'profile/edit/:id/fees-structure',
          element: <AddInstitute />
        },
        {
          path: 'profile/edit/:id/beneficiaries',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/institution_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/:id/add/fees-structure',
          element: <AddInstitute />
        },
        {
          path: 'profile/:id/add/bank_details',
          element: <AddInstitute />
        },
        {
          path: 'institution/add/beneficiaries',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/fees-structure',
          element: <AddInstitute />
        },
        {
          path: 'institution/view/:id/beneficiaries',
          element: <AddInstitute />
        },
        {
          path: 'beneficiary',
          element: <StudentDetails />
        },
        {
          path: 'requests',
          element: <RequestDetails />
        },
        {
          path: 'requests/:id',
          element: <SingleRequestDetails />
        },
        {
          path: 'education-request/:id',
          element: <EducationRequestDetails />
        },
        {
          path: 'beneficiary/add',
          element: <OnBoardingForm />
        },
        {
          path: 'beneficiary/view/:id',
          element: <OnBoardingForm mode="view" />
        },
        {
          path: 'beneficiary/edit/:id',
          element: <OnBoardingForm mode="edit" />
        },
        {
          path: 'beneficiary/request-details/:id',
          element: <StudentRequestDetails />
        }
      ]
    }
  ]
};

export default MainRoutes;
